import { AppPermission } from "@closerplatform/spinner-openapi";
import React from "react";
import { useStore } from "../../../models";
import { PermissionFallbackComponent } from "./permissionFallbackComponent";

const withPermissionFallbackTo =
  (FallbackComponent: React.ComponentType) =>
  <P extends object = {}>(permissions: AppPermission[], Component: React.ComponentType<P>) =>
  (props: P) => {
    const { uiStore } = useStore();

    return !!permissions.find((p) => uiStore.canDisplayWithPermission(p)) ? (
      <Component {...props} />
    ) : (
      <FallbackComponent />
    );
  };

/** Fallback to component if user lacks all permissions */
export const withPermissionsFallback = withPermissionFallbackTo(PermissionFallbackComponent);

/** Fallback to component if user lacks permission */
export const withPermissionFallback = <P extends object = {}>(
  permission: AppPermission,
  Component: React.ComponentType<P>
) => withPermissionFallbackTo(PermissionFallbackComponent)([permission], Component);
